module.exports = __webpack_public_path__ + "static/media/waterlinked_logo.207ebab4.svg";